import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../auth.service';
import { concatMap, filter, from, of, take } from 'rxjs';
import {
  AUTH_ROUTES,
} from '../../../shared/constants/routes.constants';

export const authChildGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isInitialized$.pipe(
    filter((isInitialized) => isInitialized),
    take(1),
    concatMap(() => {
      if (authService.isSignedIn) {
        return of(true);
      }

      return from(router.navigate(AUTH_ROUTES.ROUTER_LINK.SIGN_IN));
    }),
  );
};
